import {DialogBody} from '@chakra-ui/react'
import Barcode from 'react-barcode'

interface BarcodeDialogProps {
  barcode: string
}

export function BarcodeDialog({barcode}: BarcodeDialogProps) {
  return (
    <DialogBody
      minHeight={'none'}
      maxWidth={'100%'}
      paddingBottom={'2'}
      display="flex"
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Barcode value={barcode} renderer="svg" />
    </DialogBody>
  )
}
